<template>
  <v-dialog v-model="dialog" persistent fullscreen>
    <v-toolbar>
      <v-toolbar-title>
        Fatura Nº
        {{ invoice.id }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$printCard"><v-icon>mdi-printer</v-icon></v-btn>
      <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <div v-if="!invoice" class="text-center pa-10">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>
      <div class="pa-4" v-else id="print-card">
        <v-card
          light
          class="pa-10 d-flex flex-column mx-auto"
          width="794"
          height="1123"
        >
          <div>
            <v-row>
              <v-col cols="6" sm="6">
                <img
                  class="my-3"
                  width="160"
                  src="https://s3-eu-west-1.amazonaws.com/sga-pro/logos/sga_backg_white.png"
                />
              </v-col>
              <v-col cols="6" sm="6" class="text-right">
                <h1>
                  Fatura
                </h1>
                <div class="overline">
                  Data {{ invoice.date_register | formatDate }}
                </div>
                <strong>Fatura Nº {{ invoice.id }}</strong>
              </v-col>
            </v-row>
          </div>
          <v-divider light></v-divider>
          <div>
            <v-row>
              <v-col cols="12" sm="6">
                <h3>
                  SGA.BET - Licença de uso
                </h3>
                <!-- <h4>Platform by TITANS SOFTWARE.</h4> -->
                <p class="caption">
                  Discriminação: a renovação do seu plano é mensal, de acordo
                  com o pagamento da fatura aqui apresentada.
                </p>
                <div class="caption">
                  <span class="overline">
                    Provedor de serviço:
                  </span>
                  <br />
                  Titans Games N.V. Address : Zuikertuintjeweg Z/N (Zuikertuin
                  Tower) - Willemstad - Country: Curaçao / Zip code: 43CX+R5
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="caption" v-if="invoice.operator">
                <h3 class="overline">
                  Fatura na conta
                </h3>
                <div class="d-flex justify-space-between">
                  <div>
                    Número de conta:
                  </div>
                  <div>{{ invoice.operator.id_conta }}</div>
                </div>
                <v-divider light></v-divider>
                <div class="d-flex justify-space-between">
                  <div>
                    Cliente:
                  </div>
                  <div class="text-right">
                    {{ invoice.operator.nome }}
                  </div>
                </div>
                <v-divider light></v-divider>
                <div class="d-flex justify-space-between">
                  <div>
                    Domínio:
                  </div>
                  <div class="text-right">
                    {{ invoice.operator.url }}
                  </div>
                </div>
                <v-divider light></v-divider>
                <div class="d-flex justify-space-between">
                  <div>
                    Endereço:
                  </div>
                  <div class="text-right">
                    {{ invoice.operator.endereco }},
                    {{ invoice.operator.numero }}
                  </div>
                </div>
                <v-divider light></v-divider>
                <div class="d-flex justify-space-between">
                  <div>
                    Cidade/Estado:
                  </div>
                  <div class="text-right">
                    {{ invoice.operator.municipio }} -
                    {{ invoice.operator.estado }}
                  </div>
                </div>
                <v-divider light></v-divider>
                <div class="d-flex justify-space-between">
                  <div>
                    Código postal:
                  </div>
                  <div class="text-right">
                    {{ invoice.operator.cep }}
                  </div>
                </div>
                <v-divider light></v-divider>
              </v-col>
            </v-row>
          </div>
          <v-simple-table light class="invoice">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="black white--text text-left">
                    Título
                  </th>
                  <th class="black white--text text-left">
                    Descrição
                  </th>

                  <th class="black white--text text-left">
                    Valor Total
                  </th>

                  <!-- <th class="black white--text text-right">Unit Price (%)</th> -->
                  <th class="black white--text text-left">
                    Valor Aplicado
                  </th>

                  <th class="black white--text text-left">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="service in invoice.services" :key="service.title">
                  <td>
                    {{ service.title }}
                  </td>

                  <td>
                    {{ service.description }}
                  </td>

                  <td>
                    {{ getPortugueseMoney(service.value_total) }}
                  </td>

                  <td>
                    {{ service.value_applied }}
                  </td>

                  <td>
                    {{ getPortugueseMoney(service.value) }}
                  </td>
                </tr>
                <!-- Resume -->
                <tr>
                  <td colspan="3" style="border-bottom: 0px"></td>
                  <td
                    class="
                      text-right
                      font-weight-bold
                      black
                      white--text
                      caption
                    "
                  >
                    Subtotal
                  </td>
                  <td class="text-right">
                    {{ getPortugueseMoney(invoice.subtotal) }}
                  </td>
                </tr>
                <tr>
                  <td colspan="3" style="border-bottom: 0px"></td>
                  <td
                    class="
                      text-right
                      font-weight-bold
                      black
                      white--text
                      caption
                    "
                  >
                    Descontos
                  </td>
                  <td class="text-right">
                    {{ getPortugueseMoney(invoice.discounts) }}
                  </td>
                </tr>
                <tr>
                  <td colspan="3" style="border-bottom: 0px"></td>
                  <td
                    class="
                      text-right
                      font-weight-bold
                      black
                      white--text
                      caption
                    "
                  >
                    Total
                  </td>
                  <td class="text-right">
                    {{ getPortugueseMoney(invoice.value_charge) }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider class="mt-10"></v-divider>
          <!-- <div class="body-2 py-2">
            <strong>
              Observação:
            </strong>
            {{ invoice.observation }}
          </div> -->
          <v-divider class="mb-2"></v-divider>
          <div
            class="
              d-flex
              pb-4
              flex-grow-1
              align-end
              text-center
              caption
              justify-center
              align-end
            "
          >
            Obrigado pela sua preferência! <br />
            SGA.BET © Um produto da Empresa TITANS SOFTWARE CORP.
          </div>
        </v-card>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["invoice", "dialog"],

  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    getPortugueseMoney(value) {
      return Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },

  filters: {
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    decimalAdjustment(num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },
  },
};
</script>
<style lang="sass">
.invoice
  thead
    background: #000000
    tr th
      color: #ffffff !important
  tr:nth-child(even)
    background: rgba(255, 255, 255, 0.2)
  tr:nth-child(odd)
    background: rgba(255, 255, 255, 0.5 )
</style>
